import React from "react";
import { CheckCircle } from "lucide-react";

const InvestmentDeclaration = ({ disabled, onGoToProofs }) => {
  const investments = [
    { title: "Employee Provident Fund", desc: "Auto-populated from payroll", section: "80C", amount: "36000" },
    { title: "Public Provident Fund", desc: "Self-declared. Proof to be submitted.", section: "80C", amount: "50000" },
    { title: "ELSS mutual funds", desc: "Locked till three years", section: "80C", amount: "40000" },
    { title: "Life insurance premium", desc: "Policy on your or spouse/child", section: "80C", amount: "24000" },
    { title: "Children's tuition fees", desc: "Up to two children", section: "80C", amount: "0" },
    { title: "Home loan principal", desc: "Principal paid towards a loan", section: "80C", amount: "0" },
    { title: "Health insurance premium", desc: "Self, spouse and dependent parents (Max ₹25,000 each | ₹50,000 senior citizen)", section: "80D", amount: "25000" },
    { title: "NPS additional", desc: "Additional contribution (over and above 80C)", section: "80CCD(1B)", amount: "50000" },
    { title: "Annual rent paid", desc: "Landlord PAN needed above ₹1,00,000", section: "HRA", amount: "480000" },
    { title: "Home loan interest", desc: "On self-occupied property (Max ₹2,00,000)", section: "24(B)", amount: "0" },
  ];

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 border border-gray-100 ${disabled ? "opacity-60 pointer-events-none" : ""}`}>
      <h2 className="text-lg font-semibold mb-1">Investment Declaration</h2>
      <p className="text-sm text-gray-500 mb-6">Enter your eligible investments, deductions and exemptions for FY 2026-27.</p>
      
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-gray-100">
              <th className="py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider w-1/2">Investment / Deduction</th>
              <th className="py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Section</th>
              <th className="py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right">Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {investments.map((item, idx) => (
              <tr key={idx} className="border-b border-gray-50 last:border-0">
                <td className="py-4">
                  <div className="font-medium text-sm text-gray-900">{item.title}</div>
                  <div className="text-xs text-gray-500 mt-1">{item.desc}</div>
                </td>
                <td className="py-4 text-sm text-gray-600 font-medium">
                  {item.section}
                </td>
                <td className="py-4 text-right">
                  <input
                    type="text"
                    defaultValue={item.amount}
                    disabled={disabled}
                    className="w-24 border border-gray-200 rounded px-2 py-1.5 text-right text-sm focus:outline-none focus:border-blue-500"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex items-center justify-between mt-8">
        <div className="flex gap-4">
          <button 
            className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 px-6 rounded transition-colors"
            disabled={disabled}
          >
            Save declaration
          </button>
          <button 
            onClick={onGoToProofs}
            className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors cursor-pointer disabled:opacity-50"
          >
            Go to proofs
          </button>
        </div>
        
        <div className="flex items-center gap-2 text-green-600">
          <CheckCircle className="w-4 h-4" />
          <span className="text-sm font-medium">Projection updated.</span>
        </div>
      </div>
    </div>
  );
};

export default InvestmentDeclaration;
